<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-header">
        <h4>Change Password Form</h4>
      </div>
      <div class="card-body">
        <div class="form form-horizontal" style="margin: 15px;">
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Old Password</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="password" class="form-control" placeholder="Old Password" v-model="oldPassword">
              <small v-bind:class=" { 'd-none': verification.old } " class="form-feedback error">This field is required</small>
              <small v-bind:class=" { 'd-none': !isError } " class="form-feedback error">Old password is incorrect</small>
            </div>
          </div>
          <hr class="col-12"/>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">New Password</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="password" class="form-control" placeholder="New Password" v-model="newPassword">
              <small v-bind:class=" { 'd-none': verification.new } " class="form-feedback error">This field is required</small>
              <small v-bind:class=" { 'd-none': verification.match } " class="form-feedback error">Password doesn't match</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Retype Password</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="password" class="form-control" placeholder="Retype New Password" v-model="retype">
              <small v-bind:class=" { 'd-none': verification.re } " class="form-feedback error">This field is required</small>
              <small v-bind:class=" { 'd-none': verification.match } " class="form-feedback error">Password doesn't match</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-right p-0">
      <button class="btn btn-primary" @click="submit"><i class="fa fa-save"></i>&nbsp;&nbsp;CHANGE PASSWORD</button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      retype: null,
      verification: {
        old: true,
        new: true,
        re: true,
        match: true
      },
      isError: false
    }
  },
  methods: {
    submit () {
      if (this.verify()) {
        // do actual submit here
        var vm = this
        var data = new URLSearchParams()
        data.append('old_password', vm.oldPassword)
        data.append('new_password', vm.newPassword)
        vm.axios.post('api/user/password/change/', data)
          .then(
            (response) => {
              console.log(response)
              if (response.status === 201) {
                vm.$parent.showNotification('Password changed', 'success')
                vm.oldPassword = null
                vm.newPassword = null
                vm.retype = null
              } else {
                vm.isError = true
              }
            }
          )
      }
    },
    verify () {
      if (this.oldPassword == null || (this.oldPassword && this.oldPassword.length === 0)) {
        this.verification.old = false
        return false
      } else {
        this.verification.old = true
      }
      if (this.newPassword == null || (this.newPassword && this.newPassword.length === 0)) {
        this.verification.new = false
        return false
      } else {
        this.verification.new = true
      }
      if (this.retype == null || (this.retype && this.retype.length === 0)) {
        this.verification.re = false
        return false
      } else {
        this.verification.re = true
      }
      if (this.retype !== this.newPassword) {
        this.verification.match = false
        return false
      } else {
        this.verification.match = true
      }

      return true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/setting/ChangePassword.vue